import type { FC, PropsWithChildren } from "react";
import React from "react";

import { FetchApiClient } from "@core/ports/http";

import { githubApi, oauthApi } from "@apis/account/api";
import { busApi } from "@apis/bus/api";
import { generationApi } from "@apis/generation/api";
import { mediaApi } from "@apis/media/api";
import { memoryApi } from "@apis/memory/api";
import { taxonomyApi } from "@apis/taxonomy/api";

import { env } from "../../../bootstrap/env.ts";
import type { AuthContextValue } from "../../../shared/contexts/auth/context.ts";
import { AuthContext } from "../../../shared/contexts/auth/context.ts";
import { authStore } from "../state/auth.ts";

interface AuthProviderProps {
  readonly authToken: string;
}

export const AuthProvider: FC<PropsWithChildren<AuthProviderProps>> = ({
  authToken,
  children,
}) => {
  const getToken = (): string => authToken;
  const onUnauthorized = authStore.clearToken;
  const stage = env.STAGE;
  const value: AuthContextValue = {
    api: {
      bus: new FetchApiClient({
        api: busApi,
        getToken,
        onUnauthorized,
        stage,
      }).getApi(),
      generation: new FetchApiClient({
        api: generationApi,
        getToken,
        onUnauthorized,
        stage,
      }).getApi(),
      github: new FetchApiClient({
        api: githubApi,
        getToken,
        onUnauthorized,
        stage,
      }).getApi(),
      media: new FetchApiClient({
        api: mediaApi,
        getToken,
        onUnauthorized,
        stage,
      }).getApi(),
      memory: new FetchApiClient({
        api: memoryApi,
        getToken,
        onUnauthorized,
        stage,
      }).getApi(),
      oauth: new FetchApiClient({
        api: oauthApi,
        getToken,
        onUnauthorized,
        stage,
      }).getApi(),
      taxonomy: new FetchApiClient({
        api: taxonomyApi,
        getToken,
        onUnauthorized,
        stage,
      }).getApi(),
    },
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
